
import { Eye } from "lucide-react";

interface TableInfoTextProps {
  text: string;
}

export const TableInfoText = ({ text }: TableInfoTextProps) => {
  return (
    <div className="flex items-center space-x-2 mb-4">
      <div className="w-5 h-5 bg-gray-100 rounded-full flex items-center justify-center">
        <Eye className="w-3 h-3 text-gray-500" />
      </div>
      <p className="text-xs text-gray-500">
        {text}
      </p>
    </div>
  );
};
